/** Build a playable main-app URL from a /library action. */
export function libraryPlayUrl(system, value, { myRom = false, solo = true } = {}) {
  const params = new URLSearchParams({ system, [myRom ? 'myrom' : 'rom']: value });
  if (solo) params.set('solo', '1');
  params.set('from', 'library');
  return `/?${params.toString()}`;
}
